import type { ChatInputButtonProps } from './chat.types'

import { Button } from '../button'
import { useStyleConfig, vui } from '../core'

/**
 *  Displays a chat input button.
 */
export const ChatInputButton = vui<'button', ChatInputButtonProps>((props, ref) => {
  const styles = useStyleConfig('Chat', props)

  const { status = 'default', onSend, onStop } = props

  const icon = status === 'processing' && onStop ? 'falStopCircle' : 'falChevronCircleRight'

  return (
    <Button
      disabled={status === 'disabled' || (status === 'processing' && !onStop)}
      h="100%"
      icon={icon}
      ml={1}
      onClick={() => (status === 'processing' ? onStop?.() : onSend?.())}
      ref={ref}
      variant="tertiary"
      {...styles?.inputButton}
    />
  )
})

ChatInputButton.displayName = 'ChatInputButton'
export default ChatInputButton
